"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5.01 1v22H19V1zM17 19H7V5h10z"
}), 'StayPrimaryPortraitSharp');